// extracted by mini-css-extract-plugin
module.exports = {"main":"Board_main__2xkrZ","hide":"Board_hide__3YmKF"};